// Founder note — the honest trust section while there are no customer
// testimonials yet. No fake quotes, no invented metrics: just who made it,
// why, and a direct line. Swap/augment with real customer quotes once the
// first buyers exist.
const FOUNDER_EMAIL = 'alek@alekhagopian.com';

const FounderNote = () => {
  return (
    <section className="founder" id="founder">
      <div className="section-container">
        <p className="overline overline--center">FROM THE FOUNDER</p>
        <h2 className="section-title">Who's behind this</h2>

        <div className="founder-card">
          <p>
            I'm Alek, and I built Solidly Meet because meetings are where the actual work
            happens — and the smartest tool I own was sitting outside the room. Notetakers
            summarize a meeting after it's dead; I wanted Claude in the room with me, putting
            the pricing answer on the table while the customer is still asking. And I wanted it
            without a bot in my calls or a SaaS holding my transcripts — so it runs on your
            machine, on your own keys, because that's the only version I'd use myself.
          </p>
          <p>
            And I do use it, every day — Solidly's own sales calls, standups, and 1:1s run
            through the app. If you have a question before buying, email me directly and
            you'll get an answer from me, not a ticket queue. If it isn't for you, the 7-day
            refund is one email — no forms, no questions.
          </p>
          <p className="founder-signature">
            — Alek Hagopian, maker of Solidly ·{' '}
            <a href={`mailto:${FOUNDER_EMAIL}`}>{FOUNDER_EMAIL}</a>
          </p>
        </div>
      </div>
    </section>
  );
};

export default FounderNote;
